<app-nav-menu></app-nav-menu>
<mat-progress-bar *ngIf="showProgressBar"
                  mode="indeterminate">
</mat-progress-bar>
<div class="app-container">
    <router-outlet></router-outlet>
</div>
